<template>
  <div class="box">
    <div class="left-box" v-if="orgOpen">
      <div class="head-box">
        <h4>组织机构</h4>
        <div class="c-flex">
          <i
            class="el-icon-circle-plus-outline c-pointer"
            v-if="osg.has('OrgUser?type=b,add') || osg.has('OrgUser?type=c,add')"
            @click="orgAdd"
            title="添加组织"
          ></i>
          <i
            class="el-icon-edit c-pointer c-m-l-15"
            v-if="osg.has('OrgUser?type=b,edit') || osg.has('OrgUser?type=c,edit')"
            @click="orgEdit"
          ></i>
          <i
            class="el-icon-delete c-pointer c-m-l-15"
            v-if="osg.has('OrgUser?type=b,remove') || osg.has('OrgUser?type=c,remove')"
            @click="orgDelete"
            title="修改组织"
          ></i>
          <i
            v-if="osg.has('OrgUser?type=b,edit') || osg.has('OrgUser?type=c,edit')"
            class="el-icon-s-operation c-pointer c-m-l-15 c-pointer"
            @click="draggableOpen = true"
            title="删除组织"
          ></i>
          <i
            class="el-icon-caret-bottom c-pointer c-m-l-15"
            v-if="!fold"
            @click="
              expandedList = [];
              treeShrink('tree');
            "
            title="全部折叠"
          ></i>
          <i
            class="el-icon-caret-right c-pointer c-m-l-15"
            v-else
            @click="
              expandedList = $util.deepCopy(getChildAllOrgId(treeData));
              treeExpand('tree');
            "
            title="全部展开"
          ></i>
          <i
            class="el-icon-d-arrow-left c-pointer c-m-l-15"
            @click="orgOpen = false"
            title="左侧收起"
          ></i>
        </div>
      </div>
      <div class="filter">
        <el-select
          v-model="searchFilter"
          placeholder="筛选组织"
          clearable
          class="w-1"
          @change="filterOrgType"
        >
          <el-option
            v-for="item in options.orgType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          placeholder="请输入组织名称"
          v-model="searchOrgValue"
          clearable
          style="margin-top: 10px"
          @clear="getOrg()"
          @keyup.enter.native="getOrg()"
        ></el-input>
      </div>

      <div class="left-content tree">
        <el-tree
          refs="tree"
          ref="tree"
          :data="treeData"
          node-key="_id"
          :indent="20"
          highlight-current
          :expand-on-click-node="false"
          @node-click="orgClick"
          @node-expand="nodeExpand"
          @node-collapse="nodeCollapse"
          :props="defaultProps"
          :default-expanded-keys="expandedList"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <div slot="reference">
              <template v-if="data.orgType == 'dept'">
                <!--  <i class="fa fa-sitemap c_blue" />  -->
              </template>
              <template v-else-if="data.orgType == 'serviceCrew'">
                <!-- <i class="fa fa-users c_yellow"></i>  -->
              </template>
              <template v-else-if="data.orgType == 'partner'">
                <!-- <i class="fa fa-hands-helping c_green" /> -->
              </template>
              <!-- <span class="c-p-v-5">{{ data.order }}</span> -->
              <span class="c-p-v-5">{{ data.orgName }}</span>
              <template v-if="data.serviceResourceId">
                <!--
                <i
                  class="fa fa-business-time c_gray c_size_13 c-pointer"
                  title="服务资源"
                  @click="
                    osg.open(
                      'ServiceResource',
                      { id: data.serviceResourceId },
                      '_blank'
                    )
                  "
                />
                -->
              </template>
            </div>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="left-box" style="min-width: 0;overflow:hidden;" v-else>
      <div class="head-box">
        <div class="c-flex">
          <i class="el-icon-d-arrow-right c-pointer" @click="orgOpen = true"></i>
        </div>
      </div>
      <div style="width: 16px;margin: 10px auto;">{{ activeOrg.orgName }}</div>
    </div>
    <el-dialog title="组织机构" :visible.sync="orgDialog" width="500px">
      <el-form :model="editOrg" ref="formData" :rules="$util.rules">
        <el-form-item
          label="序号"
          label-width="100px"
          prop="order"
          :rules="{
            required: false,
            pattern: /^\d+$/,
            message: '序号填写有误，只能输入数字',
            trigger: 'blur'
          }"
        >
          <el-input v-model="editOrg.order"></el-input>
        </el-form-item>
        <el-form-item
          label="组织编号"
          label-width="100px"
          prop="orgCode"
          :rules="{
            required: true,
            pattern: /^[\w\d_-]+$/,
            message: '编号填写有误，只能由英文、数字、下划线、横线组成',
            trigger: 'blur'
          }"
        >
          <el-input v-model="editOrg.orgCode"></el-input>
        </el-form-item>
        <el-form-item
          v-if="tenantId == '4363416483534256239'"
          label="组织简称"
          label-width="100px"
          prop="shortName"
          :rules="{
            required: true,
            message: '请输入组织简称',
            trigger: 'blur'
          }"
        >
          <el-input v-model="editOrg.shortName"></el-input>
        </el-form-item>
        <el-form-item
          label="组织名称"
          label-width="100px"
          prop="orgName"
          :rules="{ required: true, trigger: 'blur', message: '名称不能为空' }"
        >
          <el-input v-model="editOrg.orgName"></el-input>
        </el-form-item>
        <el-form-item
          label="组织类型"
          label-width="100px"
          prop="orgType"
          :rules="{
            required: true,
            trigger: 'change',
            message: '组织类型不能为空'
          }"
        >
          <el-select
            v-model="editOrg.orgType"
            clearable
            :disabled="isOrgEdit && activeOrg.orgType && activeOrg.orgType == 'partner'"
          >
            <el-option
              v-for="item in options.orgType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="isOrgEdit && item.value == 'partner'"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="editOrg.orgType == 'partner'"
          label="伙伴类型"
          label-width="100px"
          prop="partnerType"
          :rules="{
            required: true,
            trigger: 'change',
            message: '伙伴类型不能为空'
          }"
        >
          <el-select v-model="editOrg.partnerType" clearable>
            <el-option
              v-for="item in options.partnerTypes"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="上级组织"
          prop="parentId"
          :rules="{
            required: true,
            trigger: 'change',
            message: '上级组织不能为空'
          }"
          label-width="100px"
        >
          <el-cascader
            ref="org"
            placeholder="可搜索组织名称"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            filterable
            clearable
            v-model="editOrg.parentId"
            @change="$forceUpdate()"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="是否开通隐私号" label-width="120px" prop="privacyNumberFlag">
          <el-radio-group v-model="editOrg.privacyNumberFlag" class="c-flex">
            <el-radio v-for="item in options['IS']" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-show="isOrgEdit && this.tenantId == '4551453470943235290'"
          label="是否禁用"
          label-width="120px"
          prop="stateFlag"
        >
          <el-radio-group v-model="stateFlag" class="c-flex">
            <el-radio v-for="item1 in options['orgState']" :key="item1.value" :label="item1.value">
              {{ item1.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="orgSave(editOrg)">确 定</el-button>
        <el-button @click="orgDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <div class="right-box">
      <div class="head-box">
        <h4>员工列表</h4>
        <div class="c-flex">
          <el-select
            style="width: auto"
            v-model="searchRoleIds"
            multiple
            clearable
            placeholder="按角色筛选"
            @change="
              fpi.page = 1;
              getUsers();
            "
          >
            <el-option
              v-for="item in options.roles"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
          <el-input
            class="c-m-l-10"
            style="width: auto"
            placeholder="请输入姓名/手机号/组织名称"
            v-model="searchValue"
            clearable
            @clear="
              fpi.page = 1;
              getUsers();
            "
            @keyup.enter.native="
              fpi.page = 1;
              getUsers();
            "
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                fpi.page = 1;
                getUsers();
              "
            ></el-button>
          </el-input>
          <el-button type="primary" class="c-m-l-10" @click="userAdd">添加员工</el-button>
          <el-button
            type="primary"
            class="c-m-l-10"
            @click="scanRegistration.show = true"
            v-if="
              osg.has('OrgUser?type=c,scanRegistration') ||
                osg.has('OrgUser?type=b,scanRegistration')
            "
          >
            扫码注册
          </el-button>
          <el-button
            type="primary"
            class="c-m-l-10"
            v-if="osg.has('OrgUser?type=c,export') || osg.has('OrgUser?type=b,export')"
            @click="userExport"
          >
            数据导出
          </el-button>
          <el-button
            type="primary"
            class="c-m-l-10"
            @click="userImport"
            v-if="osg.has('OrgUser?type=c,import') || osg.has('OrgUser?type=b,import')"
          >
            数据导入
          </el-button>
          <el-button
            type="primary"
            class="c-m-l-10"
            @click="batchEdit"
            v-if="osg.has('OrgUser?type=c,bulkEdit') || osg.has('OrgUser?type=b,bulkEdit')"
          >
            批量编辑
          </el-button>
        </div>
      </div>
      <div class="content-box">
        <div class="content-table">
          <el-table
            ref="table"
            :data="fpi.data"
            empty-text="该组织暂无人员"
            height="calc(100% - 50px)"
            highlight-current-row
            @selection-change="selectionChange"
          >
            <!--        多选框功能：1.增加多选框的一列，需要在《el-table》标签头里面加入：@selection-change="selectionChange" ，表示点击多选框时调用的函数     -->
            <el-table-column type="selection" fixed width="55"></el-table-column>
            <el-table-column prop="code" label="编号" width="100"></el-table-column>
            <div class="block">
              <span class="demonstration">多选可搜索</span>
            </div>
            <el-table-column label="姓名" width="100" fixed>
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="负责人" placement="top-end">
                  <i class="fa fa-user-tie" v-show="scope.row.isHead"></i>
                </el-tooltip>
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" width="150px"></el-table-column>
            <el-table-column label="性别" width="100px">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sex == '1' ? '女' : scope.row.sex == '0' ? '男' : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="角色" show-overflow-tooltip min-width="200px">
              <template slot-scope="scope">
                <span>{{ renderLabel('roles', scope.row.roleIds) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="orgName"
              label="服务商名称"
              min-width="200px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="服务资源" width="150px">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{
                    path: `/ServiceResource/${scope.row.serviceResourceId}`
                  }"
                >
                  <el-button type="text">{{ formatSR(scope.row.serviceResourceId) }}</el-button>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="province"
              v-if="tenantId == '4551453470943235290'"
              label="省"
              width="80px"
            >
              <template slot-scope="scope">
                <span>{{ formatProvince(scope.row.province) || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="city"
              v-if="tenantId == '4551453470943235290'"
              label="市"
              width="80px"
            >
              <template slot-scope="scope">
                <span>{{ formatCity(scope.row.city) || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="country"
              v-if="tenantId == '4551453470943235290'"
              label="区"
              width="80px"
            >
              <template slot-scope="scope">
                <span>{{ formatDistrict(scope.row.country) || '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="tags"
              label="标签"
              width="150px"
              :formatter="formatTags"
              v-if="tenantId == '1340835581184723420'"
            ></el-table-column>
            <el-table-column
              prop="serviceYears"
              label="服务年限"
              width="150px"
              v-if="tenantId == '1340835581184723420'"
            >
              <template slot-scope="scope">
                {{ osg.codelabel('serviceYears', scope.row.serviceYears) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" sortable>
              <template slot-scope="scope">
                <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                  {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" width="150px"></el-table-column>
            <el-table-column fixed="right" width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button>
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="activeOrg._id" @click.native="userHead(scope.row)">
                      {{ scope.row.isHead ? '取消负责人' : '设为负责人' }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="userEdit(scope.row)">
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        (osg.has('OrgUser?type=c,userAble') ||
                          osg.has('OrgUser?type=b,userAble')) &&
                          scope.row.state == 0
                      "
                      @click.native="doUserEnable(scope.row._id)"
                    >
                      启用
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        (osg.has('OrgUser?type=c,userAble') ||
                          osg.has('OrgUser?type=b,userAble')) &&
                          scope.row.state == 1
                      "
                      @click.native="doUserDisable(scope.row._id)"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="resetPassword(scope.row)">
                      重置密码
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('OrgUser?type=c,exception')"
                      @click.native="openBizStackTrace(scope.row)"
                    >
                      业务跟踪
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('OrgUser?type=c,snycToSicoma')"
                      @click.native="snycToSicoma(scope.row)"
                    >
                      同步到仕高码人员档案
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="pageSizeChange"
            @current-change="pageChange"
            :current-page="fpi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="fpi.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="fpi.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="员工信息"
      :visible.sync="userDialog"
      :close-on-click-modal="false"
      width="600px"
      @close="userDialogClose"
    >
      <el-steps
        v-if="!this.edit"
        :active="stepsActive"
        finish-status="success"
        style="width: 100%; margin-bottom: 40px; margin-top: 15px"
      >
        <el-step title="填写登陆账号"></el-step>
        <el-step title="填写基本信息"></el-step>
        <el-step title="设置组织负责人"></el-step>
      </el-steps>
      <el-form
        :model="editUser"
        ref="user"
        :rules="rules"
        label-width="100px"
        label-position="left"
        hide-required-asterisk:true
      >
        <div style="margin-bottom: 20px" v-show="!this.edit && stepsActive == 0">
          <i class="el-icon-info" style="margin-right: 2px"></i>
          <span style="font-size: 12px; color: #999">根据填写的账号，系统会自动填写基本信息</span>
        </div>
        <el-form-item
          label="账号"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '账号不能为空'
          }"
          v-show="!this.edit && stepsActive == 0"
        >
          <el-input v-model="editUser.accountName" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item
          label="编号"
          prop="code"
          v-show="this.edit || stepsActive == 1"
          :rules="{
            required: true,
            pattern: /^[\w\d_-]+$/,
            message: '编号填写有误，只能由英文、数字、下划线、横线组成',
            trigger: 'blur'
          }"
        >
          <el-input v-model="editUser.code"></el-input>
        </el-form-item>
        <el-form-item
          prop="orgIds"
          label="所属组织"
          v-show="this.edit || stepsActive == 1"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '所属组织不能为空'
          }"
        >
          <el-cascader
            ref="orgIds"
            placeholder="可搜索组织名称"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            filterable
            clearable
            v-model="editUser.orgIds"
            @change="$forceUpdate()"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="name" label="姓名" v-show="this.edit || stepsActive == 1">
          <el-input v-model="editUser.name"></el-input>
        </el-form-item>
        <el-form-item label="性别" v-show="this.edit || stepsActive == 1">
          <el-select v-model="editUser.sex" clearable>
            <el-option
              v-for="item in options.sex"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机" prop="phone" v-show="this.edit || stepsActive == 1">
          <el-input
            v-model="editUser.phone"
            palceholder="请输入手机号"
            :disabled="editUser._id ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          v-if="!edit"
          :prop="edit ? null : 'passwd'"
          v-show="this.edit || stepsActive == 1"
        >
          <el-input
            v-model="editUser.passwd"
            show-password
            placeholder="请输入至少6位密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email" v-show="this.edit || stepsActive == 1">
          <el-input v-model="editUser.email"></el-input>
        </el-form-item>
        <el-form-item
          v-show="this.edit"
          label="省市区"
          prop="area"
          :rules="{
            type: 'array',
            trigger: 'blur',
            message: '省市区不能为空'
          }"
        >
          <el-cascader
            :options="area.options"
            :props="area.props"
            v-model="editUser.area"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds" v-show="this.edit || stepsActive == 1">
          <el-select
            v-model="editUser.roleIds"
            multiple
            clearable
            placeholder="支持多选"
            @change="roleChange"
          >
            <el-option
              v-for="item in options.roles"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form
          :model="userServiceResource"
          ref="user"
          :rules="rules"
          label-width="100px"
          label-position="left"
          hide-required-asterisk:true
        >
          <el-form-item
            label="关联资源名称"
            v-show="this.showServiceResourceField && stepsActive == 1"
          >
            <el-input v-model="userServiceResource.name"></el-input>
          </el-form-item>
          <el-form-item
            label="关联资源描述"
            v-show="this.showServiceResourceField && stepsActive == 1"
          >
            <el-input v-model="userServiceResource.description"></el-input>
          </el-form-item>
        </el-form>
        <el-form-item
          label="标签"
          prop="tags"
          v-show="this.edit || stepsActive == 1"
          v-if="tenantId == '1340835581184723420'"
        >
          <el-select v-model="editUser.tags" multiple clearable placeholder="支持多选">
            <el-option
              v-for="item in options.userTag"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="服务年限"
          prop="serviceYears"
          v-show="this.edit || stepsActive == 1"
          v-if="tenantId == '1340835581184723420'"
        >
          <el-select v-model="editUser.serviceYears" clearable placeholder="服务年限">
            <el-option
              v-for="item in options.serviceYears"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="describe" label="简介" v-show="this.edit || stepsActive == 1">
          <el-input v-model="editUser.describe" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="照片" prop="profileImg" v-show="this.edit">
          <el-upload
            :action="upload.url"
            :data="upload.data"
            :file-list="editUser.profileImg"
            list-type="picture-card"
            :limit="1"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file, 'image');
              }
            "
            :on-success="
              (response, file, fileList) => {
                return osg.uploadSuccess(response, file, fileList, 'editUser.profileImg');
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return osg.beforeRemove(file, fileList, 'editUser.profileImg');
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :modal="false" custom-class="dialog-img" :visible.sync="upload.dialogVisible">
            <img width="100%" :src="upload.dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <el-form-item label="证件图片" prop="badgePhoto" v-show="this.edit">
          <el-upload
            :action="upload.url"
            :data="upload.data"
            :file-list="editUser.badgePhoto"
            list-type="picture-card"
            :limit="1"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file, 'image');
              }
            "
            :on-success="
              (response, file, fileList) => {
                return osg.uploadSuccess(response, file, fileList, 'editUser.badgePhoto');
              }
            "
            :on-error="osg.uploadError"
            :on-remove="
              (file, fileList) => {
                return osg.beforeRemove(file, fileList, 'editUser.badgePhoto');
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :modal="false" custom-class="dialog-img" :visible.sync="upload.dialogVisible">
            <img width="100%" :src="upload.dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
        <div style="margin-bottom: 10px" v-show="stepsActive == 2">
          <i class="el-icon-info" style="margin-right: 2px"></i>
          <span style="font-size: 12px; color: #999">
            设置为负责人，组织分单负责人将会受到短信通知
          </span>
        </div>
        <el-form-item
          label="是否设为组织负责人"
          label-width="140px"
          v-show="!this.edit && stepsActive == 2"
        >
          <el-switch v-model="editUser.isHead"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-button @click="stepsBack" v-if="!this.edit || stepsActive > 0">上一步</el-button>
        <div v-else></div>
        <el-button type="primary" v-if="!this.edit" @click="stepsNext()">
          {{ stepsActive < 2 ? '下一步' : '提 交' }}
        </el-button>
        <el-button v-else type="primary" @click="userSave()">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog title="扫码注册" :visible.sync="scanRegistration.show" class="scanRegistration">
      <el-tag style="white-space:normal;height:auto;margin-bottom:18px;">
        <i class="el-icon-info"></i>
        使用微信扫描生成的二维码进入小程序注册登录，
        将默认添加到到指定的组织，默认添加上指定的角色。
      </el-tag>
      <el-form :model="scanRegistration.formData" ref="scanRegistration" :rules="rules">
        <el-form-item
          label="组织"
          prop="orgId"
          :rules="{ required: true, message: '请选择组织', trigger: 'change' }"
        >
          <el-cascader
            v-model="scanRegistration.formData.orgId"
            :options="options.orgs"
            filterable
            clearable
            :props="{
              label: 'orgName',
              value: '_id',
              children: 'orgList',
              checkStrictly: true,
              emitPath: false
            }"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="角色"
          prop="roleIds"
          :rules="{ required: true, message: '请选择角色', trigger: 'change' }"
        >
          <el-select v-model="scanRegistration.formData.roleIds" filterable multiple clearable>
            <el-option
              v-for="item in options.roles"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="qrcode" ref="qrCode"></div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="registrationQrCode()">生成二维码</el-button>
        <el-button type="primary" @click="scanRegistration.show = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="重置密码" :visible.sync="resetDialog" width="500px">
      <el-form :model="editUser" ref="user" :rules="rules">
        <!--  <el-form-item label="姓名">
          <el-input v-model="editUser.nickname" disabled></el-input>
        </el-form-item>-->
        <el-form-item label="手机">
          <el-input v-model="editUser.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="passwd">
          <el-input disabled show-password placeholder="密码将默认设置为123456"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="resetDialog = false">取 消</el-button>
        <el-button type="primary" @click="passwordSave(editUser)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="业务跟踪"
      :visible.sync="bizStackTraceOpen"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="bizStackTraceDialog"
    >
      <bizStackTrace :params="{ sid: formData._id }" v-if="bizStackTraceOpen"></bizStackTrace>
      <div slot="footer" v-if="false">
        <el-button @click="bizStackTraceOpen = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改组织"
      :visible.sync="draggableOpen"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="bizStackTraceDialog"
    >
      <!-- <div class="c-popper"> -->
      <div class="head-box flex-1 c-flex-end">
        <el-button
          type="primary"
          icon="el-icon-caret-right c_size_14"
          v-if="fold"
          @click="treeExpand('treeDialog')"
        >
          全部展开
        </el-button>
        <el-button
          type="primary"
          icon="el-icon-caret-bottom c_size_14"
          v-else
          @click="treeShrink('treeDialog')"
        >
          全部折叠
        </el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetTree">
          重置结构
        </el-button>
      </div>

      <el-tree
        :data="treeData"
        node-key="_id"
        :indent="20"
        ref="treeDialog"
        highlight-current
        :expand-on-click-node="false"
        :props="defaultProps"
        default-expand-all
        draggable
        @node-drop="nodeDrop"
        @node-drag-end="nodeDragEnd"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <div slot="reference">
            <template v-if="data.orgType == 'dept'">
              <!--  <i class="fa fa-sitemap c_blue" />  -->
            </template>
            <template v-else-if="data.orgType == 'serviceCrew'">
              <!-- <i class="fa fa-users c_yellow"></i>  -->
            </template>
            <template v-else-if="data.orgType == 'partner'">
              <!-- <i class="fa fa-hands-helping c_green" /> -->
            </template>
            <!-- <span class="c-p-v-5">{{ data.order }}</span> -->
            <span class="c-p-v-5">{{ data.orgName }}</span>
            <template v-if="data.serviceResourceId"></template>
          </div>
        </span>
      </el-tree>
      <!-- </div> -->
      <div slot="footer">
        <el-button @click="draggableOpen = false">关 闭</el-button>
        <el-button type="primary" @click="upsertTree()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogImportVisible" width="600px">
      <el-form label-position="center" label-width="170px">
        <el-form-item label="文件">
          <el-upload
            :multiple="false"
            :on-success="onUploadSuccess"
            :action="'fsgo/excel/exportImportUser.do'"
            class="upload-demo"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传Excel文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogImportVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--批量编辑员工-->
    <el-dialog title="批量编辑员工" :visible.sync="satchEditUser" width="500px">
      <el-form :model="userCondition" ref="user" :rules="rules">
        <el-form-item
          prop="orgIds"
          label="所属组织"
          :rules="{
            trigger: 'blur',
            message: '所属组织不能为空'
          }"
        >
          <el-cascader
            ref="orgIds"
            placeholder="可搜索组织名称"
            :options="options.orgs"
            :show-all-levels="false"
            :props="{
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            filterable
            clearable
            v-model="userCondition.orgIds"
            @change="$forceUpdate()"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="角色批量操作" prop="state">
          <el-select v-model="userCondition.roleState">
            <el-option
              v-for="item in options.isRole"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="角色"
          prop="roleIds"
          v-if="userCondition.roleState == 1 || userCondition.roleState == 0"
        >
          <el-select v-model="userCondition.roleIds" multiple clearable placeholder="支持多选">
            <el-option
              v-for="item in options.roles"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="state">
          <el-select v-model="userCondition.state">
            <el-option
              v-for="item in options.state"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="satchEditUser = false">取 消</el-button>
        <el-button type="primary" @click="batchEditUser(userCondition)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  name: 'orgUser',
  components: {
    bizStackTrace: () => import('../components/bizStackTrace')
  },
  data() {
    return {
      //地址级联-懒加载
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true
        }
      },
      privacyNumberFlag: '0',
      stateFlag: '0',
      showServiceResourceField: false,
      userServiceResource: {
        name: '', //资源名称
        description: '' //资源描述
      }, //关联服务资源
      isShow: false,
      selectedList: [], //多选框功能：2.初始化被选中的员工记录
      dialogImportVisible: false,
      satchEditUser: false,
      tenantId: '', //租户id
      type: '',
      activeTab: 'org', //当前激活tab
      orgDialog: false,
      activeOrg: '', //当前选中组织
      editOrg: '', //当前编辑的组织
      treeData: [], //所有组织
      defaultProps: {
        children: 'orgList',
        label: 'orgName'
      },
      userDialog: false, //是否显示编辑人员
      resetDialog: false, //是否显示重置密码框
      options: {
        sex: [{ label: '男', value: 0 }, { label: '女', value: 1 }],
        state: [
          { name: '不操作', value: -1 },
          { name: '启用', value: 1 },
          { name: '禁用', value: 0 }
        ],
        isRole: [
          { name: '不操作', value: -1 },
          { name: '添加角色', value: 1 },
          { name: '移除角色', value: 0 }
        ],
        roles: [],
        codecfg_orgType: { codeId: 'ORGTYPE' },
        codecfg_partnerTypes: { codeId: 'partnerTypes' },
        codecfg_userTag: { codeId: 'userTag' },
        codecfg_serviceYears: { codeId: 'serviceYears' },
        codecfg_IS: { codeId: 'IS' },
        codecfg_orgState: { codeId: 'orgState' }
      },
      searchValue: '', //搜索关键词
      searchRoleIds: [], //角色筛选
      fpi: {},
      //员工列表
      editUser: {}, //编辑人员信息
      edit: false, //新增false 编辑true
      rules: this.$util.rules,
      searchFilter: '',
      isOrgEdit: false, //组织机构 新增false 编辑true,
      searchOrgValue: '', //搜索组织
      stepsActive: 0, //员工信息步骤
      //员工列表
      userCondition: {}, //批量编辑人员信息
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      bizStackTraceOpen: false, //业务跟踪弹窗
      orgOpen: true,
      expandedList: [], //控制是否展开
      draggableOpen: false, //拖拽组织弹窗
      fold: false, //是否折叠的状态
      //扫码注册
      scanRegistration: {
        show: false,
        formData: {
          roleIds: []
        },
        orgData: []
      }
    };
  },
  mounted() {
    window.$this = this;
    this.type = this.osg.param('type');
    if (this.type == 'c') this.type = ''; // c查全部 b查b
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.osg.codeoption(() => {
      this.getOrg(treeData => {
        this.expandedList = this.$util.deepCopy(this.getChildAllOrgId(treeData));
      });
    });
    this.osg.getFpi();
    this.getRoles();
    // this.getUsers();
  },
  methods: {
    //多选框功能：3.点击多选框的调用函数，这里会将当前已选中的员工记录赋值给selectedList
    roleChange() {
      if (this.editUser.roleIds.includes('4585674895642246643')) {
        this.stepsActive = 1;
        this.showServiceResourceField = true;
      } else {
        this.showServiceResourceField = false;
      }
    },
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //获取所有子元素中有子元素的orgid
    getChildAllOrgId(arr, noRecursion) {
      let ids = [];
      function getId(arr) {
        arr.forEach(item => {
          if (Array.isArray(item.orgList) && item.orgList.length) ids.push(item._id);
          if (Array.isArray(item.orgList) && !noRecursion) getId(item.orgList);
        });
      }
      getId(arr);
      return ids;
    },
    //根据组织顺序、父子组织，赋值order
    deassignOrg(arr, parentId) {
      arr.forEach((item, index) => {
        item.order = index + 1;
        if (item._id != this.tenantId) {
          // console.log(item.orgName, item._id, item.parentId, parentId, 'pid');
          item.parentId = parentId;
        }
        if (Array.isArray(item.orgList) && item.orgList.length) {
          this.deassignOrg(item.orgList, item._id);
        }
      });
    },
    formatSex(row, column, cellValue) {
      if (cellValue == 0) return '女';
      else if (cellValue == 1) return '男';
      else return '未知';
    },
    //渲染服务资源
    formatSR(value) {
      return this.osg.codelabel('serviceResource', value);
    },
    formatTags(row, column, cellValue) {
      return this.osg.codelabelForArray('userTag', cellValue);
    },
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getUsers();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getUsers();
    },
    //添加组织
    orgAdd() {
      this.editOrg = {
        parentId: this.activeOrg._id || this.tenantId
      };
      this.isOrgEdit = false;
      this.orgDialog = true;
    },
    //点击组织
    orgClick(obj) {
      this.activeOrg = this.$util.deepCopy(obj);
      this.fpi.page = 1;
      this.getUsers();
    },
    //获取组织
    getOrg(callback) {
      let params = {
        'is:orgType|string#and': this.searchFilter,
        'regex:orgName|string#and': this.searchOrgValue,
        notFilterOrgId: '1',
        sortField: 'order'
      };
      this.osg.ajax('org/query.do', params, res => {
        var obj = res.data;
        // TODO:根组织名称不支持修改
        if (this.tenantId == '1340835581184723420') {
          obj.orgName = '顶之美';
        } else {
          obj.orgName = '全部组织';
        }
        this.treeData = [obj];
        if (callback) callback(this.treeData);
        this.activeOrg = obj;
        // 保存全部组织，作为编辑人员的所属组织组件选项
        if (!this.searchFilter && !this.searchOrgValue) {
          this.options.orgs = this.treeData;
        }
      });
    },
    //编辑组织组织
    orgEdit() {
      if (!this.activeOrg) {
        this.osg.toast('请选择要编辑的组织！', 'warning');
        return;
      }
      if (this.activeOrg._id == this.tenantId) {
        this.osg.toast('不允许编辑根组织', 'warning');
        return;
      }
      this.editOrg = this.activeOrg;
      this.privacyNumberFlag = this.editOrg.privacyNumberFlag
        ? this.editOrg.privacyNumberFlag + ''
        : '0';
      this.stateFlag = this.editOrg.state ? this.editOrg.state + '' : '0';
      this.editOrg.state = this.activeOrg.state + '';
      this.isOrgEdit = true;
      this.orgDialog = true;
    },
    //保存组织
    orgSave() {
      if (this.osg.validate()) {
        let org = this.editOrg;
        if (org._id == org.parentId) {
          this.osg.toast('不能选择当前组织作为上级组织！', 'warning');
          return;
        }
        org.partnerId = org.partnerId || this.activeOrg.partnerId || ''; //伙伴及伙伴下组织保存伙伴id
        org.state = 1;
        delete org.orgList;
        delete org.tenantId;
        if (org._id != '' && org._id != undefined) {
          org.state = this.stateFlag;
        } else {
          org.state = 1;
        }
        this.osg.ajax('org/upsert.do', org, () => {
          this.osg.toast('保存成功！');
          this.orgDialog = false;
          this.getOrg();
          this.getUsers();
        });
      }
    },
    //删除组织组织
    orgDelete() {
      if (!this.activeOrg) {
        this.osg.toast('请选择要删除的组织！', 'warning');
        return;
      } else if (this.activeOrg._id == this.tenantId) {
        this.osg.toast('不允许删除根组织', 'warning');
        return;
      } else {
        let msg = `是否确认删除"${this.activeOrg.orgName}"`;
        if (this.activeOrg.serviceResourceId) {
          msg += '，关联的服务资源也将删除！';
          this.removeServiceResource(this.activeOrg.serviceResourceId);
        }
        this.osg.confirm(msg, () => {
          this.osg.ajax(`org/remove/${this.activeOrg._id}.do`, {}, res => {
            this.osg.toast('删除成功！');
            this.getOrg();
          });
        });
      }
    },
    //获取员工列表
    getUsers() {
      let params = {
        'in:state|array-integer#and': '0,1',
        'in:orgIds|array#and': this.activeOrg._id == this.tenantId ? null : this.activeOrg._id,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:orgName|string#or': this.searchValue,
        'in:roleIds|array#and': this.searchRoleIds.join(),
        sortField: 'createTime',
        sortOrder: 'asc',
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20
      };
      this.osg.setFpi(params);
      this.osg.ajax('user/query.do', params, async res => {
        let list = [];
        res.data.map(item => {
          // 解析图片
          item.profileImg = this.renderUserImg(item.profileImg);
          item.badgePhoto = this.renderUserImg(item.badgePhoto);

          if (item.serviceResourceId) list.push(item.serviceResourceId);
          //查询当前组织负责人id与员工列表的_id，相等则为负责人
          if (this.activeOrg.supervisorIds || (res.entity && res.entity.supervisorIds)) {
            let someArr = this.activeOrg.supervisorIds || res.entity.supervisorIds;
            if (someArr.some(el => el == item._id)) item.isHead = true;
          }
        });
        // 不展示租户管理员账号
        res.data = res.data.filter(item => {
          return item._id != item.tenantId;
        });
        if (list.length > 0) {
          await new Promise(resolve => {
            this.osg.ajax(
              'biz/serviceResource/query.do',
              {
                page: 1,
                rows: list.length,
                'in:_id|array#and': list.join(',')
              },
              response => {
                response.data.map(item => {
                  item.label = item.name;
                  item.value = item._id;
                });
                this.options.serviceResource = response.data;
                resolve();
              }
            );
          });
        }
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    batchEdit() {
      //这里将选中的员工列表数据赋值给data，接下来对data进行操作就是对已经选中的员工列表数据操作
      var data = this.selectedList;
      if (data.length > 0) {
        this.satchEditUser = true;
      } else {
        this.$message.error('未选择员工数据');
      }
    },
    batchEditUser(editUser) {
      if (editUser.roleIds != undefined && editUser.roleIds.length > 0) {
        var roleIds = editUser.roleIds.join(',');
      }
      var orgIds = null;
      if (undefined != editUser.orgIds) {
        orgIds = editUser.orgIds;
      }
      var userIds = [];
      this.selectedList.forEach(item => userIds.push(item._id));
      userIds = userIds.join(',');
      let data = {
        userIds: userIds,
        roleIds: roleIds,
        orgIds: orgIds,
        roleState: editUser.roleState,
        state: editUser.state
      };
      this.osg.ajax('/user/batchEditUser.do', data, response => {
        if (response.success == false) {
          this.$message.error(response.message);
        }
        if (response.success == true) {
          this.$message.info('操作成功');
          this.satchEditUser = false;
          this.getUsers();
        }
      });
    },
    //导入员工
    userImport() {
      this.dialogImportVisible = true;
    },
    // 导入成功后的提醒
    onUploadSuccess(response, file) {
      if (response.success == true) {
        this.$message.info('导入成功');
        this.dialogImportVisible = false;
        this.getUsers();
      }
      if (response.success == false) {
        this.$message.error(response.message);
      }
    },
    //导出成功回调
    offlineExportBack() {
      this.osg.alert('操作成功！正在生成文件... 点击跳转查看', () => {
        //this.$router.push({ path: '/Stask' });
      });
    },
    //导出全部员工
    userExport() {
      var jsonListMap = {
        title: '员工列表',
        userExport: 'userExport',
        姓名: 'name',
        手机号: 'phone',
        角色: 'roleIds',
        所属组织: 'orgName',
        状态: 'serviceAppointmentStatus',
        编号: 'code',
        服务资源: 'serviceResourceId',
        省: 'province',
        市: 'city',
        区: 'country',
        创建时间: 'createTime',
        创建人: 'createUser'
      };
      var jsonList = [jsonListMap];
      var searchObj = [];
      this.osg.ajax(
        'excel/export.do',
        Object.assign(searchObj, {
          jsonList: JSON.stringify(jsonList)
        }),
        res => {
          // 对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let temp = res.headers['content-disposition'].split('=')[1];
          let iconv = require('iconv-lite');
          iconv.skipDecodeWarning = true; //忽略警告
          let fileName = iconv.decode(temp, 'gbk');
          const _res = res.data;
          let blob = new Blob([_res]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        },
        {
          url: 'excel/offlineExport.do',
          headers: { 'content-type': 'application/json;charset=utf-8' },
          responseType: 'blob'
        },
        this.offlineExportBack()
      );
    },
    //渲染图片
    renderUserImg(imgData) {
      if (imgData) {
        if (this.$util.isJson(imgData)) {
          imgData = JSON.parse(imgData);
        }
      } else {
        imgData = [];
      }
      return imgData;
    },
    //保存图片
    saveUserImg(imgData) {
      imgData = imgData || []; //创建人员时无照片
      imgData.map(item => {
        if (item.url.indexOf('blob:') != -1) {
          item.url = this.upload.downloadUrl + item.response.key;
        }
      });
      return JSON.stringify(imgData);
    },
    //添加用户
    userAdd() {
      if (!this.$refs.tree.getCurrentKey()) {
        this.osg.toast('请选择组织！', 'warning');
        return;
      }
      this.edit = false;
      this.editUser = {
        orgIds: this.activeOrg._id || this.tenantId
      };
      this.userServiceResource = {};
      this.showServiceResourceField = false;
      this.userDialog = true;
    },
    //编辑员工
    userEdit(row) {
      this.userServiceResource = {};
      this.edit = true;
      let formData = this.$util.deepCopy(row);
      // TODO:组织限制单选
      formData.orgIds = formData.orgIds[0];
      this.editUser = formData;
      if (this.editUser.roleIds.includes('4585674895642246643')) {
        this.stepsActive = 1;
        this.showServiceResourceField = true;
      }
      this.osg.ajax(
        `biz/serviceResource/findById/${this.editUser.serviceResourceId}.do`,
        null,
        res => {
          if (res != '') {
            this.userServiceResource = res;
          }
        }
      );
      this.userDialog = true;
    },
    // 设为负责人
    userHead(row) {
      var org = this.$util.deepCopy(this.activeOrg);
      if (!this.$refs.tree.getCurrentKey()) {
        this.osg.toast('请选择组织！', 'warning');
        return;
      }
      org.parentId = org.parentId || this.activeOrg._id || this.tenantId;
      org.state = 1;
      let isCancelHead = !org.supervisorIds
        ? -1
        : org.supervisorIds.findIndex(item => item == row._id);
      if (isCancelHead != -1) {
        org.supervisorIds.splice(isCancelHead, 1);
      } else {
        org.supervisorIds && org.supervisorIds.length
          ? org.supervisorIds.push(row._id)
          : (org.supervisorIds = [row._id]);
      }
      delete org.orgList;
      delete org.tenantId;
      this.osg.ajax('org/upsert.do', org, res => {
        this.activeOrg = res.entity;
        this.osg.toast('保存成功！');
        this.orgDialog = false;
        let params = {
          'is:orgType|string#or': this.searchFilter,
          'regex:orgName|string#or': this.searchOrgValue,
          notFilterOrgId: '1',
          sortField: 'order,createTime'
        };
        this.osg.ajax('org/query.do', params, res => {
          var obj = {};
          // TODO:根组织名称不支持修改
          if (this.tenantId == '1340835581184723420') {
            obj.orgName = '顶之美';
          } else {
            obj.orgName = '全部组织';
          }
          obj.orgList = res.data.orgList;
          var data = [obj];
          this.treeData = data;
          this.$nextTick(() => {
            //保持住选中的菜单
            this.$refs.tree.setCurrentKey(this.activeOrg._id);
            this.getUsers();
          });
        });
      });
    },
    //保存员工
    userSave() {
      var pass;
      this.$refs['user'].validate(valid => {
        if (valid) pass = true;
      });
      if (!pass) return;

      let editUser = this.$util.deepCopy(this.editUser);
      if (!editUser._id) editUser.state = 1;
      editUser.roleIds = editUser.roleIds.join(',');

      //保存人员所属组织 组件保存的值是字符串，需要转为数组
      if (editUser.orgIds) {
        editUser.orgIds = [editUser.orgIds];
      } else {
        editUser.orgIds = [this.tenantId];
      }
      editUser.orgId = editUser.orgIds[0] || '';
      if (this.edit && editUser.area != undefined && editUser.area != '') {
        editUser.orgId = editUser.orgIds[0] || '';
        editUser.province = editUser.area[0];
        editUser.city = editUser.area[1];
        editUser.country = editUser.area[2];
      }
      // editUser.orgIds = editUser.orgIds || [];
      // if (this.activeOrg._id) {
      //   if (editUser.orgIds.indexOf(this.activeOrg._id) == -1) {
      //     editUser.orgIds.push(this.activeOrg._id);
      //   }
      //   editUser.orgId = this.activeOrg._id;
      // } else {
      //   //全部组织
      //   if (editUser.orgIds.length == 0) {
      //     editUser.orgIds.push(this.tenantId);
      //   }
      //   editUser.orgId = editUser.orgId || this.tenantId;
      // }

      //保存人员的伙伴id
      editUser.partnerId = this.activeOrg.partnerId || '';

      //gpsPoint格式转换
      if (editUser.gpsPoint) {
        editUser['gpsPoint.longitude'] = editUser.gpsPoint.longitude;
        editUser['gpsPoint.latitude'] = editUser.gpsPoint.latitude;
        delete editUser.gpsPoint;
      }

      delete editUser.isHead;
      delete editUser.accountName;
      // this.activeOrg.supervisorIds
      // return;

      // 保存人员账户类型和组织名称
      editUser.accountType = 'b';
      // editUser.orgName = editUser.orgName || this.activeOrg.orgName;
      editUser.orgName = this.$refs.orgIds.getCheckedNodes()[0].label;

      // 头像存储
      editUser.profileImg = this.saveUserImg(editUser.profileImg);
      //证件图片储存
      editUser.badgePhoto = this.saveUserImg(editUser.badgePhoto);
      let exts = {
        serviceResourceName: this.userServiceResource.name,
        serviceResourceDescription: this.userServiceResource.description
      };
      delete editUser.avatar;
      delete editUser.headimgurl;
      this.$set(editUser, 'exts', exts);
      this.osg.ajax('user/upsert.do', editUser, res => {
        // console.log(editUser, '------------------editUser');
        // 设为负责人
        if (this.editUser.isHead && !this.edit) this.userHead({ _id: res.data._id });
        this.osg.toast('保存成功');
        this.userDialog = false;
        this.editUser = {};
        this.stepsActive = 0;
        this.getUsers();
      });
    },
    doUserEnable(id) {
      this.osg.ajax(`user/enable/${id}.do`, {}, () => {
        this.osg.toast('启用成功');
        this.getUsers();
      });
    },
    doUserDisable(id) {
      this.osg.ajax(`user/disable/${id}.do`, {}, () => {
        this.osg.toast('禁用成功');
        this.getUsers();
      });
    },
    //删除员工
    userDelete(row) {
      let msg = '是否确认删除 ' + row.name + '？';
      if (row.serviceResourceId) {
        msg += '，关联的服务资源也将删除！';
        this.removeServiceResource(row.serviceResourceId);
      }
      this.osg.confirm(msg, () => {
        row.orgIds.length == 1 ? (row.state = '-1') : (row.state = '0');
        row.orgIds = row.orgIds.filter(item => item != this.activeOrg._id);
        row.serviceResourceId = '';
        this.osg.ajax('user/upsert.do', row, () => {
          this.osg.toast('删除成功！');
          this.getUsers();
        });
      });
    },
    //获取所有角色
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:type|string#and': this.type,
          notFilterOrgId: '1'
        },
        res => {
          this.options.roles = res.data;
          this.getUsers();
        }
      );
    },
    // 在节点展开是添加到默认展开数组
    nodeExpand(data) {
      this.$nextTick(() => {
        let arr = this.getChildAllOrgId([data], true);
        arr.forEach(item => this.expandedList.push(item));
      });
    },
    // 收起时删除数组里对应选项
    nodeCollapse(data) {
      this.$nextTick(() => {
        let arr = this.getChildAllOrgId([data]);
        arr.forEach(item => {
          if (this.expandedList.indexOf(item) != -1) {
            this.expandedList.splice(this.expandedList.indexOf(item), 1);
          }
        });
      });
    },
    //打开业务跟踪弹窗
    openBizStackTrace(row) {
      row = this.$util.deepCopy(row);
      this.formData = row;
      this.bizStackTraceOpen = true;
    },
    //重置密码
    resetPassword(row) {
      this.editUser = this.$util.deepCopy(row);
      this.resetDialog = true;
    },
    //重置密码保存
    passwordSave(obj) {
      this.osg.ajax('/user/resetPassword/' + obj.fsgoUnionId + '.do', {}, res => {
        this.osg.toast('密码重置成功！');
        this.resetDialog = false;
        this.getUsers();
      });
    },
    //渲染列
    renderLabel(list, values) {
      var label = '';
      for (var value of values) {
        for (var item of this.options[list]) {
          if (value == item._id) {
            label += ' ' + item.name + ' ';
          }
        }
      }
      return label;
    },
    filterOrgType() {
      this.getOrg();
    },
    //删除user或org关联的服务资源
    removeServiceResource(id) {
      this.osg.ajax(`biz/serviceResource/remove/${id}.do`, null, res => {});
    },
    //员工信息步骤-上一步
    stepsBack() {
      if (this.stepsActive-- < 1) this.stepsActive = 0;
    },
    //员工信息步骤-下一步
    async stepsNext() {
      let checkPhone = /^1[3456789]\d{9}$/;
      let checkEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

      if (this.stepsActive == 0) {
        //第一步仅对账户进行必填校验
        if (!this.editUser.accountName) {
          this.osg.toast('请输入账号！', 'warning');
          return;
        } else if (!checkPhone.test(this.editUser.accountName)) {
          this.osg.toast('账号格式有误，请输入手机号！', 'warning');
          return;
        } else if (checkPhone.test(this.editUser.accountName)) {
          //根据账户类型自动填写
          this.editUser.phone = this.editUser.accountName;
        } else if (checkEmail.test(this.editUser.accountName)) {
          this.editUser.email = this.editUser.accountName;
        }
        let accountAvailable = false;
        //检测账户是否在其他租户下
        await this.accountAvailable(this.editUser.accountName).then(res => {
          accountAvailable = res.success;
          if (res && res.data) {
            let editUserData = {
              accountName: res.data.accountName,
              phone: res.data.phone,
              // code: res.data.code,
              name: res.data.name
            };
            this.editUser = this.$util.deepCopy(Object.assign(this.editUser, editUserData));
          } else {
            this.editUser = this.$util.deepCopy(
              Object.assign(this.editUser, {
                name: ''
              })
            );
          }
        });
        if (!accountAvailable) return;
      } else if (this.stepsActive == 1) {
        //第二步对所有字段进行必填校验
        var pass;
        this.$refs['user'].validate(valid => {
          if (valid) pass = true;
        });
        if (!pass) return;
      }
      if (this.stepsActive++ >= 2) {
        this.userSave();
      }
      // this.userSave();
    },
    //员工信息弹窗关闭回调
    userDialogClose() {
      this.stepsActive = 0;
      this.editUser = {};
    },
    //检测账号是否在其他租户下
    accountAvailable(accountName) {
      return new Promise(resolve => {
        this.osg.ajax('account/checkAccountAvailable.do', { accountName: accountName }, res => {
          resolve({ success: true, data: res.data });
        });
      });
    },
    //拖拽组织成功完成时触发的事件
    nodeDrop() {
      // 共四个参数，依次为：被拖拽节点对应的 Node、结束拖拽时最后进入的节点、被拖拽节点的放置位置（before、after、inner）、event
      // console.log(node, leaveNode, event, this.treeData);
      // this.$nextTick(() => {
      // console.log('修改后', this.treeData);
      // });
    },
    //拖拽组织结束时触发的事件
    nodeDragEnd(node, overNode, local, event) {
      // 共四个参数，依次为：被拖拽节点对应的 Node、结束拖拽时最后进入的节点（可能为空）、被拖拽节点的放置位置（before、after、inner）、event
      if (overNode.data._id == this.tenantId && local == 'before') {
        this.osg.toast('操作失败，根组织不能修改！', 'error');
        this.getOrg();
      }
      // console.log(node, overNode, local, event);
    },
    //重置组织树
    resetTree() {
      this.getOrg(treeData => {
        this.expandedList = this.$util.deepCopy(this.getChildAllOrgId(treeData));
        this.osg.toast('操作成功！');
      });
    },
    //更改组织数结构
    upsertTree() {
      this.deassignOrg(this.treeData);
      this.osg.ajax('org/upsertTree.do', { tree: JSON.stringify(this.treeData[0]) }, res => {
        this.draggableOpen = false;
        this.osg.toast('操作成功！');
        this.getOrg();
      });
    },
    //全部组织展开
    treeExpand(treeName) {
      this.$nextTick(() => {
        for (var i = 0; i < this.$refs[treeName].store._getAllNodes().length; i++) {
          this.$refs[treeName].store._getAllNodes()[i].expanded = true;
        }
        this.fold = false;
      });
    },
    //全部组织折叠、收起
    treeShrink(treeName) {
      this.$nextTick(() => {
        for (var i = 0; i < this.$refs[treeName].store._getAllNodes().length; i++) {
          this.$refs[treeName].store._getAllNodes()[i].expanded = false;
        }
        this.fold = !this.fold;
      });
    },
    formatProvince(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(cellValue) {
      if (!cellValue) return '';
      return this.osg.areaObj.county_list[cellValue];
    },
    snycToSicoma(row) {
      this.osg.ajax(
        'person/upsertPerson.do',
        {
          user: row
        },
        () => {}
      );
    },
    // 生成注册二维码
    registrationQrCode() {
      if (this.osg.validate('scanRegistration')) {
        // if (this.qrcode) {
        this.$refs.qrCode.innerHTML = '';
        // }
        new QRCode(this.$refs.qrCode, {
          text: `https://www.fsgo365.cn/qrcode/logon/?tenantId=${this.tenantId}&orgId=${
            this.scanRegistration.formData.orgId
          }&roleIds=${this.scanRegistration.formData.roleIds.join()}`,
          width: 200,
          height: 200,
          colorDark: '#333333', //二维码颜色
          colorLight: '#ffffff', //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        });
      }
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.type = this.osg.param('type');
      if (this.type == 'c') this.type = ''; // c查全部 b查b
      this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
      this.osg.codeoption(() => {
        this.getOrg();
      });
      this.osg.getFpi();
      this.getRoles();
    }
    // expandedList(oldVal, newVal) {
    //   console.log(oldVal, newVal, 'expandedList');
    // }
  }
};
</script>
<style scoped>
.filter {
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 8px;
  padding: 0 6px;
}
.el-step__head.is-process {
  color: rgb(84, 92, 100);
  border-color: rgb(84, 92, 100);
}
.el-step__title.is-process {
  color: rgb(84, 92, 100);
}
.left-content {
  height: calc(100% - 150px) !important;
}
::v-deep .scanRegistration .qrcode img {
  margin: 18px auto;
}
</style>
